export var TemplateType;
(function (TemplateType) {
    TemplateType["UNKNOWN"] = "UNKNOWN";
    TemplateType["STUDIO"] = "STUDIO";
    TemplateType["ORGANIZATION"] = "ORGANIZATION";
    TemplateType["CLIENT"] = "CLIENT";
    TemplateType["PUBLIC"] = "PUBLIC";
})(TemplateType || (TemplateType = {}));
export var Platform;
(function (Platform) {
    Platform["STUDIO"] = "STUDIO";
    Platform["WIX"] = "WIX";
})(Platform || (Platform = {}));
export var SiteGeneratedSourceType;
(function (SiteGeneratedSourceType) {
    SiteGeneratedSourceType["UNKNOWN_SITE_GENERATED_SOURCE_TYPE"] = "UNKNOWN_SITE_GENERATED_SOURCE_TYPE";
    SiteGeneratedSourceType["MARKETPLACE_ORDER"] = "MARKETPLACE_ORDER";
    SiteGeneratedSourceType["SHAREABLE_LINK"] = "SHAREABLE_LINK";
})(SiteGeneratedSourceType || (SiteGeneratedSourceType = {}));
export var Source;
(function (Source) {
    Source["NONE"] = "NONE";
    Source["MARKETPLACE"] = "MARKETPLACE";
    Source["SATELLITE"] = "SATELLITE";
})(Source || (Source = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map